import script from "./SpeechSchedule.vue?vue&type=script&setup=true&lang=ts"
export * from "./SpeechSchedule.vue?vue&type=script&setup=true&lang=ts"

import "./SpeechSchedule.vue?vue&type=style&index=0&id=79cc464e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79cc464e"]])

export default __exports__